import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Form, Card } from "react-bootstrap";
import axios from "axios";
import Preloader from "../../../shared/PreLoaders";
import { logActivity } from "../../../utils/LogActivity";
import { AuthContext } from "../../../Context/AuthContext";
import { Authorization } from "../../../Context/Authorization";
const DailyLoanReport = () => {
  const [vfc, setVfc] = useState(""); // State for selected VFC ID
  const [vfcName, setVfcName] = useState(""); // State for selected VFC Name
  const [date, setDate] = useState(""); // State for selected date
  const [loanData, setLoanData] = useState({
    individualLoans: 0,
    groupLoans: 0,
    totalLoans: 0,
  });
  const [vfcOptions, setVfcOptions] = useState([]); // State to store VFCs
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;
  const { access, userId } = useContext(AuthContext);

  useEffect(() => {
    setLoading(true);
    const fetchVfcs = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, config);
        const data = response.data.vfcs;
        if (Array.isArray(data)) {
          const filteredVfcData = data.filter((vfc) =>
            access.vfcId.includes(vfc._id)
          );
          setVfcOptions(filteredVfcData);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (error) {
        console.error("Error fetching VFCs", error);
      }
      setLoading(false);
    };
    fetchVfcs();
  }, []);

  // Fetch loan data when VFC or date changes
  useEffect(() => {
    if (vfc && date) {
      fetchLoanData(vfc, date);
    }
  }, [vfc, date]);

  // Function to fetch loan data
  const fetchLoanData = async (selectedVfc, selectedDate) => {
    setLoading(true);
    try {
      const config = Authorization();
      const response = await axios.post(
        `${Api}/api/loan-collections/daily-loan-report`,
        {
          vfcId: selectedVfc,
          date: selectedDate,
        },
        config
      );
      const data = response.data;
      setLoanData({
        individualLoans: data.individualLoan, // Fix key
        groupLoans: data.groupLoan, // Fix key
        totalLoans: data.totalLoan, // Fix key
      });
    } catch (error) {
      console.error("Error fetching loan data", error);
    }
    setLoading(false);
    await logActivity(
      userId,
      "Visited Daily Loan Report",
      "DailyLoanReport Page",
      Api
    );
  };

  // Handle VFC change, set both VFC ID and Name
  const handleVfcChange = (e) => {
    const selectedVfcId = e.target.value;
    const selectedVfc = vfcOptions.find(
      (option) => option._id === selectedVfcId
    );
    setVfc(selectedVfcId);
    setVfcName(selectedVfc ? selectedVfc.vfcName : "");
  };

  return (
    <div>
      <Preloader loading={loading} />

      <div className="page-header">
        <h3 className="page-title"> Daily Loan Report </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Daily Loan Report
            </li>
          </ol>
        </nav>
      </div>

      <Container className="mt-5">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <Row>
                <Col md={6}>
                  <Form>
                    <Form.Group controlId="selectVfc">
                      <Form.Label>Select VFC</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          as="select"
                          value={vfc}
                          onChange={handleVfcChange}
                        >
                          <option value="">Select VFC</option>
                          {vfcOptions.map((vfcOption) => (
                            <option key={vfcOption._id} value={vfcOption._id}>
                              {vfcOption.vfcName}
                            </option>
                          ))}
                        </Form.Control>
                      </div>
                    </Form.Group>

                    <Form.Group controlId="selectDate">
                      <Form.Label>Select Date</Form.Label>
                      <div className="input-container">
                        <Form.Control
                          type="date"
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>
                    </Form.Group>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-icon-text mt-3"
                      onClick={() => fetchLoanData(vfc, date)}
                    >
                      <i className="mdi mdi-file-check btn-icon-prepend"></i>
                      Fetch Report
                    </button>
                  </Form>
                </Col>

                <Col md={6}>
                  <Card>
                    <Card.Body>
                      <Card.Title>
                        <p className="card-description">
                          Loan Report for {vfcName ? vfcName : "selected VFC"}{" "}
                          on {date ? date : "selected date"}
                        </p>
                      </Card.Title>
                      <Card.Text>
                        Individual Loans: {loanData.individualLoans}
                      </Card.Text>
                      <Card.Text>Group Loans: {loanData.groupLoans}</Card.Text>
                      <Card.Text>Total Loans: {loanData.totalLoans}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DailyLoanReport;
